import { Box } from "@mui/material";
import ScopeDetail from "../_components/ScopeDetail";

interface Props {
  preview?: boolean;
}

const ScopeThree = ({ preview }: Props) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
      <ScopeDetail scopeId="Scope-3" preview={preview} />
    </Box>
  );
};

export default ScopeThree;
